export const formatPoiName = (poi, poiName) => {
  const poiNum = parseInt(poi);
  if (isNaN(poiNum)) return "N/A";

  const value = (poiName || "").trim();
  const formattedPoiNum = poiNum.toFixed(0) + "°";

  return `${value} ${formattedPoiNum}`.trim();
};
